import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {AlertProvider} from '../../providers/alert/alert';
import {NewRegistrationStep2Page} from '../new-registration-step2/new-registration-step2';

/**
 * Generated class for the ProofTermsBeforeBeginPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-registration-terms',
  templateUrl: 'new-registration-terms.html',
})
export class NewRegistrationTermsPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    // private proof: ProofProvider,
    // private proofServer: ProofServerProvider,
  ) {
  }

  onBack() {
    this.navCtrl.pop();
  }

  onDecline() {
    // this.alertProvider.doWaiting('Registrando...');
    // // this.proofServer.termsNoAcceptance(this.proof.getId()).subscribe({
    // //   next: (): void => {
    // //     window.location.reload();
    // //     this.alertProvider.doWaitingHide();
    // //   },
    // //   error: (err: any): void => {
    // //     console.error(err);
    // //     this.alertProvider.doWaitingHide();
    // //   }
    // // });
    //
    // this.navCtrl.pop({
    //   animation: 'ios-transition'
    // });
    this.alertProvider.doAlert('Para concluir seu cadastro, é necessário aceitar o Termo de Uso e a Política de Privacidade. Sem essa confirmação, o processo de cadastro não poderá ser finalizado. Em caso de dúvidas ou dificuldades, entre em contato com o Instituto Totum pelo e-mail: certificacaorpps@institutototum.com.br',
      'Aviso Importante');
  }

  onAccept() {
    this.alertProvider.doWaiting('Registrando...');

    this.navCtrl.push(NewRegistrationStep2Page, {}, {
      animation: 'ios-transition'
    });

    // this.proofServer.termsAcceptance(this.proof.getId()).subscribe({
    //   next: (): void => {
    //     this.navCtrl.push(ProofBeforeBeginPage);
    //     this.alertProvider.doWaitingHide();
    //   },
    //   error: (err: any): void => {
    //     console.error(err);
    //     this.alertProvider.doWaitingHide();
    //   }
    // });
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-registration-terms/new-registration-terms.ts